<template>
    <section v-show="getAdviser" class="consultores">
      <b-container fluid>
        <b-row class="mb-3">
          <b-col>
            <br/><br/>
            <h2 class="text-center">Consultores</h2>
          </b-col>
        </b-row>

        <!-- Botão para adicionar novo consultor -->
         <b-row class="mb-3">
            <b-col class="text-right">
            <b-button v-if="userActive.length > 0 && userActive[0].active == 1" variant="primary" @click="openModal('create')">
                + Adicionar Consultor
            </b-button>
            </b-col>
        </b-row>
        <!-- Campo de pesquisa -->
        <b-row class="mb-2">
          <b-col md="4" class="ml-auto">
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="🔍 Pesquisar..."
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- Tabela com scroll e cabeçalhos fixos -->
        <div class="table-container" style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd;">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 10%;">DATA</th>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 20%;">NOME</th>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 15%;">TIPO</th>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 18%;">TELEFONE</th>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 20%;">E-MAIL</th>
                <th style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 7%;">CÓDIGO</th>
                <th v-if="userActive.length > 0 && userActive[0].active == 1" style="background-color: #1c879b; color: white; position: sticky; top: 0; font-weight: bold; width: 7%;">EDITAR</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredData" :key="item.code">
                <td>{{ item.created_at }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.code }}</td>
                <td v-if="userActive.length > 0 && userActive[0].active == 1">
                  <button type='button' class='find-data invisible-button detail-button' @click="editConsultor(item)"><i class='find-data fa fa-search-plus'></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-container>

      <!-- Modal para adicionar ou editar consultor -->
      <b-modal 
            v-model="showModal"
            hide-header
            @hidden="resetForm"
            hide-footer
            centered
        >
        <!-- Cabeçalho Personalizado -->
        <div id="header-row" class="d-flex justify-content-between align-items-center w-100 p-3">
            <p id="header-title" class="mb-0 font-weight-bold">{{ modalTitle }}</p>
            <i class="fas fa-times" id="close-button" @click="closeModal"></i>
        </div>
        <br>
        <b-form @submit.prevent="modalMode === 'create' ? saveConsultor() : updateConsultor()">
          <b-form-group label="Consultor" label-for="name" label-class="font-weight-bold">
            <b-form-input id="name" v-model="newAdviser.name" required></b-form-input>
          </b-form-group>

          <b-form-group label="Tipo" label-for="tipo" label-class="font-weight-bold">
            <b-form-select
              id="tipo"
              v-model="newAdviser.type"
              :options="tipoOptions"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Telefone" label-for="phone" label-class="font-weight-bold">
            <b-form-input
              id="phone"
              v-model="newAdviser.phone"
              v-mask="'+55 (##) #####-####'"
              placeholder="Digite o telefone"
              maxlength="19"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="E-mail" label-for="email" label-class="font-weight-bold">
            <b-form-input id="email" v-model="newAdviser.email" @input="validateEmail" type="email" required></b-form-input>
          </b-form-group>
          <p v-if="emailError" style="color: red; font-size: 12px;">{{ emailError }}</p>
          <b-form-group label="Código" label-for="code" label-class="font-weight-bold">
            <b-form-input id="code" v-model="newAdviser.code" disabled></b-form-input>
          </b-form-group>

          <button type="submit" variant="success" class="btn btn-success cursor-pointer" id="btn-save"><i class="fa fa-save"></i>{{ modalMode === 'create' ? 'Salvar' : 'Atualizar' }}</button>
          <button type="button" class="btn btn-danger cursor-pointer" id="btn-delete" @click="deleteConsultor" v-if="modalMode === 'edit'"><i class="fa fa-trash"></i>    Excluir</button>
        </b-form>
      </b-modal>
    </section>
  </template>
  
  <script>
  import { BContainer, BRow, BCol, BFormInput, BInputGroup } from 'bootstrap-vue';
  import axios from 'axios';
  import { mapGetters } from "vuex";
  import moment from 'moment';
  import VueTheMask from 'vue-the-mask';
  
  Vue.use(VueTheMask)
  
  
  export default {
    name: "Consultores",
    components: {
      BContainer,
      BRow,
      BCol,
      BFormInput,
      BInputGroup,
    },
    data() {
      return {
        adviser: [],
        userActive: [],
        filter: "", // Valor do filtro de pesquisa
        showModal: false,
        modalMode: "create", // Adiciona esta propriedade
        newAdviser: {
            id: null,
            name: "",
            type: "Consultor", // Valor padrão
            phone: "",
            email: "",
            code: ""
        },
        emailError: "", // Armazena a mensagem de erro do e-mail
        optionsTelInput: {
          placeholder: 'Insira o telefone',
          required: true
        },
        tipoOptions: [
          { value: 'Consultor', text: 'Consultor' },
          { value: 'Supervisor', text: 'Supervisor' }
        ],
      };
    },
    computed: {
    ...mapGetters(["getAdviser"]),
    filteredData() {
        if (!this.filter) {
            return this.adviser; // Retorna todos se o filtro estiver vazio
        }
        const search = this.filter.toLowerCase();

        const result = this.adviser.filter(item => 
            (item.name || "").toLowerCase().includes(search) ||
            (item.type || "").toLowerCase().includes(search) ||
            (item.email || "").toLowerCase().includes(search) ||
            (item.phone || "").toLowerCase().includes(search) ||
            (item.code || "").toLowerCase().includes(search)
        );

        return result;
    },

    modalTitle() {
        return this.modalMode === "create" ? "Adicionar Consultor" : "Editar Consultor";
      }
    },
    created() {
      this.loadAdvisers();
      var user = new User;
      this.loadActiver(user.getExtension());
      console.log('[ADVISER] My Extension:', user.getExtension());
    },
    methods: {
        validateEmail() {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (this.newAdviser.email && !emailPattern.test(this.newAdviser.email)) {
                this.emailError = "Por favor, insira um e-mail válido.";
            } else {
                this.emailError = "";
            }
        },
        closeModal() {
            this.showModal = false; // Fecha o modal
            this.resetForm();
        },
        formTelefone(tel) {
          if( (tel.length == 10) || (tel.length == 11) ) {
            const v1 = tel.replace(/\D/g,"");
            const v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
            const v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
            
            return v3;
          }
          tel=tel.replace(/\D/g,"");
          tel=tel.replace(/^(\d)/,"+$1");
          tel=tel.replace(/(.{3})(\d)/,"$1($2");
          tel=tel.replace(/(.{6})(\d)/,"$1)$2");
          if(tel.length == 12) {
            tel=tel.replace(/(.{1})$/,"-$1");
          }
          else if (tel.length == 13) {
            tel=tel.replace(/(.{2})$/,"-$1");
          }
          else if (tel.length == 14) {
            tel=tel.replace(/(.{3})$/,"-$1");
          }
          else if (tel.length == 15) {
            tel=tel.replace(/(.{4})$/,"-$1");
          }
          else if (tel.length > 15) {
            tel=tel.replace(/(.{4})$/,"-$1");
          }
          tel=tel.replace("("," (");
          tel=tel.replace(")",") ");

          return tel;
        },
        loadActiver(extension) {
          axios.get('listUserActive', {
            params: {
              id: extension
            }
          })
          .then(({ data }) => {
            if (Array.isArray(data)) {
              this.userActive = data.map(item => ({
                id: item.id,
                name: item.name,
                extension_line: item.extension_line,
                login: item.login,
                active: item.active
              }));
            } else {
              this.userActive = [];
            }
          })
          .catch(error => {
            console.error('Erro ao carregar usuários ativos:', error);
            this.userActive = [];
          });
        },

        loadAdvisers() {
            axios.get('listUserAdviser')
                .then(({ data }) => {
                this.adviser = data.map(item => ({
                    id: item.id,
                    created_at: moment(item.created_at).format('DD/MM/YYYY HH:mm:ss'),
                    name: item.name,
                    type: item.type,
                    email: item.email,
                    phone: this.formTelefone(item.phone),
                    code: item.code
                }));
                })
                .catch(err => {
                console.error('Erro ao carregar Consultores:', err);
                });
        },
        openModal(mode) {
            this.modalMode = mode;
            this.showModal = true;
        },
        editConsultor(consultor) {
            this.newAdviser = { ...consultor };
            this.openModal("edit");
        },
        updateConsultor() {
            axios.post("updateUserAdviser", {
                id: this.newAdviser.id,
                name: this.newAdviser.name,
                type: this.newAdviser.type,
                phone: this.newAdviser.phone.replace(/\D/g, ""),
                email: this.newAdviser.email
            }).then((data) => {
                Swal.fire(
                "Atualização realizada",
                "Os dados deste consultor foram atualizados",
                "success"
                ).then((confirm) => {
                    this.showModal = false;
                    this.loadAdvisers();
                    this.resetForm();
                });
            })  
            .catch(err => console.error('Erro ao atualizar Consultor:', err));
        },
        deleteConsultor() {
            
            axios
                .post("destroyAdviser", { id: this.newAdviser.id })
                .then((data) => {
                Swal.fire(
                    "Registro Excluído",
                    "Este consultor não faz mais parte de sua base",
                    "success"
                ).then((confirm) => {
                    this.showModal = false;
                    this.loadAdvisers();
                    this.resetForm();
                    })
            });
        },
        saveConsultor() {
            axios.get("getLastUserAdviserCode") // Obtém o último código salvo
            .then(({ data }) => {
                let lastCode = data?.code || "*1"; // Se não houver código, inicia do "*0"
                let nextNumber = parseInt(lastCode.replace("*", "")) + 1; // Incrementa o número
                this.newAdviser.code = `*${nextNumber}`; // Define o novo código
                
                // Envia os dados para salvar
                return axios.post('addUserAdviser', this.newAdviser);
            })
            .then(({ data }) => {
                // Verifica se há erros de validação
                if (data.passed === false) {
                    let str = '';
                    Object.keys(data.errors).forEach(key => {
                        str += `${data.errors[key]}\n`; // Junta os erros em uma string
                    });

                    Swal.fire({
                        icon: "warning",
                        title: "Falha ao salvar consultor",
                        text: str
                    });

                    return;
                }

                // Se passou na validação, exibe sucesso
                Swal.fire({
                    icon: "success",
                    title: "Feito!",
                    text: "Consultor salvo com sucesso!"
                }).then(() => {
                    this.showModal = false;
                    this.loadAdvisers(); // Atualiza a tabela após salvar
                    this.resetForm(); // Reseta o formulário
                });
            })
            .catch(err => {
                console.error("Erro ao salvar Consultor:", err);
                Swal.fire({
                    icon: "error",
                    title: "Erro!",
                    text: "Ocorreu um erro ao salvar o consultor. Tente novamente."
                });
            });
        },
        resetForm() {
            this.newAdviser = {
                name: "",
                type: "",
                phone: "",
                email: "",
                code: ""
            };
        }
    }
  };
  </script>
  
  <style scoped>

#btn-save i {
  margin-right: 5px; /* Ajuste conforme necessário */
}

#btn-save {
  color: white;
  background-color: #034103;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-save:hover {
  color: #034103;
  background-color: white;
  border: 3px solid #034103;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-delete {
  color: white;
  background-color: #aa1a1a;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-delete:hover {
  color: #aa1a1a;
  background-color: white;
  border: 3px solid #aa1a1a;
  border-radius: 10px !important;
  transition: 0.5s;
}

#header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #1c869a;
    border-top: 2px solid #f38630; /* Diminui a espessura da borda */
    padding: 5px 10px; /* Reduz o preenchimento para diminuir a altura */
    border-radius: 10px 10px 0 0;
}

#header-title {
    color: white;
    font-weight: bold;
    margin: 0;
}

#close-button {
    font-weight: bold;
    background-color: white;
    color: #aa1a1a;
    cursor: pointer;
    border: 1px solid #aa1a1a;
    border-radius: 25%;
    font-size: 12px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#close-button:hover {
    background-color: #aa1a1a;
    color: white;
    transition: 0.3s;
}
  .text-center {
    text-align: center;
  }
  
  .mb-3 {
    margin-bottom: 1rem;
  }
  
/* Remove qualquer z-index elevado da tabela */
.table-container {
  position: relative;
  overflow-x: auto;
  background: white; /* Evita qualquer fundo transparente */
}

.table {
  width: 100%;
  table-layout: fixed;
}

.table td, .table th {
  padding: 8px;
  word-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis; /* Ainda mantém os "..." quando necessário */
  white-space: normal; /* Permite que o texto quebre a linha */
}
  </style>
  